<footer class="bg-white border-t border-gray-100">
    <div class="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <!-- Main Footer Content -->
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 xl:gap-12">
            <!-- Company Info -->
            <div class="col-span-1 md:col-span-2 lg:col-span-1">
                <img src="assets/images/logo/i2-logo-footer.svg" 
                     alt="Industry Intelligence Inc." 
                     class="h-9 w-auto mb-6">
                <p class="text-sm text-gray-600 leading-relaxed mb-8">
                    {{ companyDescription }}
                </p>
                
                <!-- LinkedIn Only -->
                <div class="mt-auto">
                    <a *ngFor="let social of socialLinks | slice:0:1"
                       [href]="social.url"
                       [attr.aria-label]="social.label"
                       target="_blank"
                       rel="noopener noreferrer"
                       class="inline-flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:text-gray-900 border border-gray-200 rounded-md transition-colors hover:border-gray-300">
                        <i class="fab fa-{{ social.icon }}"></i>
                        <span>Follow us on LinkedIn</span>
                    </a>
                </div>
            </div>

            <!-- Products Column -->
            <div>
                <h3 class="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-5">
                    {{ footerMenuItems[0].title }}
                </h3>
                <ul class="space-y-3">
                    <li *ngFor="let link of footerMenuItems[0].links">
                        <a [routerLink]="link.route" 
                           class="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            {{ link.title }}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Solutions By Industry Column -->
            <div>
                <h3 class="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-5">
                    Solutions By Industry
                </h3>
                <ul class="space-y-3">
                    <li *ngFor="let link of footerMenuItems[1].links">
                        <a [routerLink]="link.route" 
                           class="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            {{ link.title }}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- More Solutions + Resources Column -->
            <div>
                <!-- More Solutions Section -->
                <h3 class="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-5">
                    Solutions By Function
                </h3>
                <ul class="space-y-3">
                    <li *ngFor="let link of footerMenuItems[2].links">
                        <a [routerLink]="link.route" 
                           class="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            {{ link.title }}
                        </a>
                    </li>
                </ul>

                <!-- Resources Section -->
                <h3 class="text-sm font-semibold text-gray-900 uppercase tracking-wider mt-8 mb-5">
                    {{ footerMenuItems[3].title }}
                </h3>
                <ul class="space-y-3">
                    <li *ngFor="let link of footerMenuItems[3].links">
                        <a [routerLink]="link.route" 
                           class="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            {{ link.title }}
                        </a>
                    </li>
                </ul>
            </div>

            <!-- Company Column -->
            <div>
                <h3 class="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-5">
                    {{ footerMenuItems[4].title }}
                </h3>
                <ul class="space-y-3">
                    <li *ngFor="let link of footerMenuItems[4].links">
                        <a [routerLink]="link.route" 
                           class="text-sm text-gray-600 hover:text-gray-900 transition-colors">
                            {{ link.title }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>

        <!-- Footer Bottom -->
        <div class="mt-12 pt-8 border-t border-gray-100">
            <div class="flex flex-col sm:flex-row justify-between items-center">
                <!-- Legal Links -->
                <div class="flex flex-wrap items-center gap-6 mb-6 sm:mb-0">
                    <span class="text-sm text-gray-500">© {{ currentYear }} Industry Intelligence Inc.</span>
                    <ng-container *ngFor="let link of legalLinks">
                        <a [routerLink]="link.route" 
                           class="text-sm text-gray-500 hover:text-gray-900 transition-colors">
                            {{ link.title }}
                        </a>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</footer>